// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__1ZXZi","amount":"Amount_amount__2lT2L","tip":"Amount_tip__2qZxM","tipHeader":"Amount_tipHeader__3Bn2d","tipsWrap":"Amount_tipsWrap__11t_w"};